<div class="container-">
    <survey-creator #surveyCreator [json]="json" (surveySaved)="onSurveySaved($event)" [attr.data-testid]="uid"></survey-creator>
</div>
